import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import './HeaderImage.module.css';

HeaderImage.PropTypes = {
  data: PropTypes.shape({
    headerImage: PropTypes.object,
  }),
};

function HeaderImage({ data }) {

  return (
    <div styleName="HeaderImage" >
      <Img
        sizes={{
          ...data.headerImage.sizes,
          base64: data.headerImage.sqip.dataURI,
        }}
        title={`${data.slogan_line1} ${data.slogan_line2}`}
        alt=""
        style={{
          minHeight: 400,
          maxHeight: 900,
          borderBottom: '3px solid #B58F44',
        }}
      />
      <div styleName="overlayContainer">
        <div className="wrapper">
          <div styleName="overlay">
            <span>{data.slogan_line1}</span><br />
            <span>{data.slogan_line2}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderImage;




// WEBPACK FOOTER //
// ./src/components/Header/HeaderImage.js